import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';
import { GroupDetailPrice, NextStepBtn } from '@components/DetailPage';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from './styles.module.scss';

interface I_Anchor {
    isShow: boolean;
    to: string; // 錨點連結位置
    text: string; // 錨點文字
}

const StickyHeader = () => {
    const { GroupInfo } = useSelector((state: RootState) => state.groupReducer);
    const { isAnchorShow } = useSelector((state: RootState) => state.switcherReducer);
    const {
        Features,
        Remark,
        ActiveNote,
        ItinnotesReg,
        SafeReg,
        LeaveTeamReg,
        OptionalInfoList,
        DailyList,
    } = useSelector((state: RootState) => state.itinerariesReducer);
    const [isFeeOpen, setIsFeeOpen] = useState<boolean>(false);
    const { t } = useTranslation();
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });
    const currency = GroupInfo.CurrencyCode || '';

    const headerAnchors = [
        {
            isShow: !!Features,
            to: 'feature',
            text: '行程特色',
        },
        {
            isShow: DailyList.length > 0,
            to: 'schedules',
            text: '每日行程',
        },
        {
            isShow: OptionalInfoList.length > 0,
            to: 'activities',
            text: '自費活動',
        },
        {
            isShow: !!Remark,
            to: 'notes',
            text: '行程特殊提醒',
        },
        {
            isShow: !!ItinnotesReg && isPC,
            to: 'itineraryNote',
            text: '行程備註',
        },
        {
            isShow: !!ActiveNote && isPC,
            to: 'activeNote',
            text: '活動附註',
        },
        {
            isShow: !!SafeReg && isPC,
            to: 'safety',
            text: '安全守則',
        },
        {
            isShow: !!LeaveTeamReg && isPC,
            to: 'leaveTeam',
            text: '團體航班規定事項',
        },
    ];

    // 若為 "額滿"、"關團"、"取消"、"關團(因疫情）"，則 disable 按鈕
    const disabledBtn = [3, 5, 7, 99].includes(GroupInfo.Status);
    // 即將開放(僅按鈕disable其餘文案正常顯示)
    const comingSoon = [9].includes(GroupInfo.Status);

    const statusText = (status: number) => {
        switch (status) {
            case 1:
                return '報名';
            case 2:
                return '候補';
            case 3:
                return '額滿';
            case 4:
                return '請洽專員';
            case 5:
                return t('closeGroup');
            case 6:
                return '預訂';
            case 7:
                return '取消';
            case 8:
                return '我有意願';
            case 9:
                return '即將開賣';
            // 因應疫情
            case 99:
                return t('closeGroup');
            default:
                return '';
        }
    };

    // 確認行程錨點資料
    const stickyHasData = headerAnchors.some((item: any) => item.isShow === true);

    return stickyHasData && isAnchorShow ? (
        <div className={styles.stickyHeader}>
            <ul className={styles.stickyHeader_wrapper}>
                {headerAnchors.map(
                    (anchor: I_Anchor, i: number) =>
                        anchor.isShow && (
                            <li key={i} className={styles.stickyHeader_item}>
                                <Link
                                    activeClass={styles.active}
                                    className={styles.link}
                                    to={anchor.to}
                                    spy={true}
                                    smooth={true}
                                    duration={500}
                                    offset={isPC ? -140 : -35}
                                >
                                    {anchor.text}
                                </Link>
                            </li>
                        )
                )}
                {isPC && (
                    <li className={styles.stickyHeader_element}>
                        {!disabledBtn && (
                            <>
                                <div className={styles.price}>
                                    <span className={styles.price_rate}>
                                        {GroupInfo.Status == 6
                                            ? '近期上架'
                                            : `${currency} ${GroupInfo.Price}`}
                                    </span>
                                    人/起
                                </div>
                                <GroupDetailPrice
                                    open={isFeeOpen}
                                    ToggleLightBox={() => setIsFeeOpen(false)}
                                />
                                <div
                                    className={styles.price_info}
                                    onClick={() => setIsFeeOpen(true)}
                                >
                                    費用說明
                                </div>
                            </>
                        )}
                        <NextStepBtn
                            statusText={statusText(GroupInfo.Status)}
                            disabledBtn={disabledBtn}
                            comingSoon={comingSoon}
                        />
                    </li>
                )}
            </ul>
        </div>
    ) : null;
};

export default StickyHeader;
